"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of the Parameter contract. Calls down to the impl
 * class for almost all of the work it does.
 */
class Parameter {
    constructor(parameterImpl) {
        this.parameterImpl = parameterImpl;
    }
    get name() {
        return this.parameterImpl.name;
    }
    get currentValue() {
        return this.parameterImpl.currentValue;
    }
    get dataType() {
        return this.parameterImpl.dataType;
    }
    get allowableValues() {
        return this.parameterImpl.allowableValues;
    }
    get id() {
        return this.parameterImpl.id;
    }
    changeValueAsync(newValue) {
        return this.parameterImpl.changeValueAsync(newValue);
    }
}
exports.Parameter = Parameter;
//# sourceMappingURL=Parameter.js.map